import { getCompanies } from "../../../../api/companies"

export const MASTER_FIELDS = []

export const MEDIA_FIELDS = [
    { 
        key: 'company', 
        label: "company", 
        type: "select", 
        api: getCompanies, 
        apiResKey: 'companies',
        // isMulti: true
    },
]

const FIELDS = [
    ...MEDIA_FIELDS,
    ...MASTER_FIELDS
]

export default FIELDS


